// extracted by mini-css-extract-plugin
export default {"project-content-container":"ProjectContent_project-content-container__m1kEz","files-not-found":"ProjectContent_files-not-found__sd2EE"};